import { Component, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, FormArray, Validators } from "@angular/forms";
import { MatDialog } from "@angular/material";
import { ActivatedRoute, Route, Router } from "@angular/router";
import { ToastService } from "ng-uikit-pro-standard";
import { DataService } from "src/app/data.service";
import { GUID } from "src/app/guid";
@Component({
  selector: "app-domainsettingsconfigkey",
  templateUrl: "./domainsettingsconfigkey.component.html",
  styleUrls: ["./domainsettingsconfigkey.component.scss"],
})
export class DomainsettingsconfigkeyComponent implements OnInit {
  @ViewChild("editPicklistDialog", { static: false })
  editPicklistDialog!: TemplateRef<any>;

  @ViewChild("standardPicklistDialog", { static: false })
  standardPicklistDialog!: TemplateRef<any>;

  // domainForm: FormGroup;
  guid: GUID;
  mode = "new";
  isLoading = false;
  domainfieldsid: string;
  domainfields: any;
  sectionid: string = "";
  section: string = "";
  dataSource: any;
  isError = false;
  errorMessage = "";
  newPicklistValue: string = "";
  //  domainForm!: FormGroup;

  // picklist///

  showEditPicklistDialog: boolean = false;
  editPicklistForm: FormGroup;
  picklistOptions = [];
  selectedIndex: any;
  editpicklistdialogRef: any;
  standardpicklistdialogRef: any;
  showStandardPicklist = false;
  valuePicklistForm: FormGroup;

  attributeForm: FormGroup;
  attributeitems: FormArray;
  oldValues: any = {}; // To store the old values
  displayedColumns: string[] = [
    "action",
    "picklistlabel",
    "picklistname",
    "defaultpicklist",
    // 'modifiedby',
    // 'modifieddate'
  ];
  // relatedToSelect: Array<{ value: string; label: string }> = [];

  relatedToSelect = [
    { value: "Users", label: "Users" },
    { value: "Queue", label: "Queue" },
    { value: "Template", label: "Template" },
  ];
  fieldTypeSelect = [
    { value: "bool", label: "Boolean" },
    // { value: "int", label: "Integer" },
    // { value: "decimal", label: "Decimal" },
    { value: "date", label: "Date" },
    // { value: "datetime", label: "DateTime" },
    { value: "text", label: "Text" },
    { value: "picklist", label: "Picklist" },
    { value: "lookup", label: "Lookup" },
    // { value: "json", label: "JSON" },
  ];

  //  createItem(a: any, t: any, v: any, p = "", h: any): FormGroup {
  //     return this.fb.group({
  //       attr: a,
  //       type: t,
  //       value: v,
  //       placeholder: p,
  //       hint: h,
  //     });
  //   }

  constructor(
    private fb: FormBuilder,
    public dialog: MatDialog,
    private route: ActivatedRoute,
    private router: Router,
    private toastrService: ToastService,
    private dataService: DataService
  ) {}

  domainForm = this.fb.group({
    name: [""],
    label: [""],
    datatype: [""],
    sortorder: [0], // ✅ ADD THIS
    defaultvalue: [""],
    newPicklistValue: [""], // 👈 added this
    // picklistvalues: this.fb.array([]), // 👈 added this
    picklistvalues: [""],
    minvalue: [""],
    maxvalue: [""],
    deprecated: [false],
    active: [false],
    relatedto: [""],
  });

  ngOnInit() {
    this.guid = new GUID();

    this.attributeForm = this.fb.group({
      fieldid: "",
      fieldname: "",
      attributeitems: this.fb.array([]),
    });

    this.route.queryParams.subscribe((params) => {
      this.mode = this.route.snapshot.params.mode;
      this.sectionid = this.route.snapshot.params.sectinid;
      this.section = this.route.snapshot.params.section;
      this.domainfieldsid = this.route.snapshot.params.id;
      console.log("Section Item:", this.sectionid);
      console.log("Section Item:", this.section);
    });

    this.valuePicklistForm = this.fb.group({
      placeholder: ["", Validators.required], // Example control for placeholder
      sortbyalphabet: false,
    });

    //    this.domainForm.get('datatype').valueChanges.subscribe(value => {
    //   if (value === 'picklist') {
    //     this.domainForm.get('picklistvalues').enable();
    //   } else {
    //     this.domainForm.get('picklistvalues').disable();
    //     this.domainForm.get('picklistvalues').reset();
    //   }
    // });

    // this.domainForm.get('datatype').valueChanges.subscribe(value => {
    //   if (value === 'picklist') {
    //     this.domainForm.get('picklistvalues').enable();
    //   } else {
    //     this.domainForm.get('picklistvalues').disable();
    //     this.domainForm.get('picklistvalues').reset();
    //   }
    // });

    if (this.mode.toLowerCase() == "edit") {
      this.getDomainfieldsedit();
    }
    // this.getActiveObjectsByType();

    this.domainForm.get("datatype").valueChanges.subscribe((type) => {
      const relatedCtrl = this.domainForm.get("relatedto");
      if (type === "lookup") {
        relatedCtrl.setValidators([Validators.required]);
      } else {
        relatedCtrl.clearValidators();
        relatedCtrl.setValue("");
      }
      relatedCtrl.updateValueAndValidity();
    });

    this.domainForm.get("name").valueChanges.subscribe((val) => {
      if (val && val.includes(" ")) {
        this.domainForm.get("name").setValue(val.replace(/\s+/g, ""), {
          emitEvent: false,
        });
      }
    });
  }
  removeSpaces(event: ClipboardEvent) {
    let paste = event.clipboardData.getData("text") || "";
    paste = paste.replace(/\s+/g, ""); // remove all spaces

    event.preventDefault();
    this.domainForm.get("name").setValue(paste);
  }

  // getActiveObjectsByType() {
  //   return new Promise((resolve) => {
  //     const postOption = {
  //       organizationid: localStorage.getItem("crm_orgid"),
  //       userid: localStorage.getItem("crm_userid"),
  //       domain: localStorage.getItem(
  //         `${localStorage.getItem("crm_orgid")}.domain`
  //       ),
  //       subdomain: localStorage.getItem(
  //         `${localStorage.getItem("crm_orgid")}.subdomain`
  //       ),
  //       data: {
  //         metaobject: { objecttype: "Admin" },
  //       },
  //     };

  //     this.isLoading = true;

  //     this.dataService.getActiveObjectsByType(postOption).subscribe(
  //       (res) => {
  //         if (res.success === 1 && res.data.metaobjects) {
  //           const objArr = [{ value: "", label: "--None--" }];
  //           console.log("Meta Objects:", res.data.metaobjects);
  //           res.data.metaobjects.forEach((obj) => {
  //             objArr.push({
  //               value: obj.name, // ✅ backend expects NAME
  //               label: obj.name,
  //             });
  //           });

  //           this.relatedToSelect = objArr;
  //         }

  //         this.isLoading = false;
  //         resolve(null);
  //       },
  //       (err) => {
  //         console.error("getActiveObjectsByType error", err);
  //         this.isLoading = false;
  //         resolve(null);
  //       }
  //     );
  //   });
  // }

  // Get picklist FormArray

  get picklistValues(): FormArray {
    return this.domainForm.get("picklistvalues") as FormArray;
  }
  // Add new picklist value
  // addPicklistValue(): void {
  //   const value = this.newPicklistValue.trim();
  //   if (!value) {
  //     this.toastrService.warning('Please enter a value before adding.');
  //     return;
  //   }

  //   this.picklistValues.push(this.fb.control(value));
  //   this.newPicklistValue = '';
  // }

  // addPicklistValue(): void {
  //   const value = this.domainForm.get('newPicklistValue').value.trim();
  //   if (!value) {
  //     this.toastrService.warning('Please enter a value before adding.');
  //     return;
  //   }

  //   this.picklistValues.push(this.fb.control(value));
  //   this.domainForm.get('newPicklistValue').reset();
  // }

  // Remove a picklist value
  removePicklistValue(index: number): void {
    this.picklistValues.removeAt(index);
  }

  cancel() {
    // this.router.navigateByUrl('home/domainsettinglist');
    this.router.navigateByUrl(
      `home/domainfieldslist/${this.section}/${this.sectionid}`
    );
  }

  saveReOrderPicklist() {
    this.standardpicklistdialogRef.close();
  }

  reorder(): void {
    // this.showStandardPicklist = !this.showStandardPicklist;
    this.showStandardPicklist = true;
    // this.editPicklistForm = this.fb.group({
    //   picklistlabel: "",
    //   picklistname: "",
    //   defaultpicklist: false,
    // });
    this.standardpicklistdialogRef = this.dialog.open(
      this.standardPicklistDialog,
      {
        // data: this.data,
        height: "300px",
        width: "600px",
        // disableClose: true,

        panelClass: "custom-dialog-class",
      }
    );

    // this.propertiesDialog = dialogRef.componentInstance;
    // this.propertiesDialog.setParent(this);

    this.standardpicklistdialogRef.afterClosed().subscribe((result) => {
      console.log("Properties dialog was closed");
      if (result) {
      }
    });
  }

  picklistvalueNew(): void {
    // Show the form
    this.showEditPicklistDialog = true;

    // Initialize a blank form
    this.editPicklistForm = this.fb.group({
      picklistlabel: [""],
      picklistname: [""],
      defaultpicklist: [false],
    });

    this.editpicklistdialogRef = this.dialog.open(this.editPicklistDialog, {
      // data: this.data,
      height: "400px",
      width: "600px",
      // disableClose: true,

      panelClass: "custom-dialog-class",
    });
  }

  picklistValueChangedOld(event: { target: { value: any } }) {
    var options = [];
    console.log(event);
    console.log("event", event.target.value);
    var txtValue = event.target.value;
    if (txtValue != "") {
      var arr = txtValue.split("\n");
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].trim() != "") {
          options.push({
            value: arr[i],
            label: arr[i],
          });
        }
      }
    }

    var optionValue = JSON.stringify(options);
    console.log("value", optionValue);
    this.picklistOptions = options;

    if (options != null) {
      this.dataSource = options.map((item) => ({
        // id: item.id,
        // label: item.labelname,
        picklistlabel: item.label,
        picklistname: item.value,
        funnelstages: item.funnelstages,
        defaultpicklist: item.defaultpicklist,
      }));
    }

    var arrayControl = this.attributeForm.get("attributeitems") as FormArray;
    for (let c of arrayControl.controls) {
      if (c.get("attr").value == "options") {
        // c.get("value").setValue(optionValue);
        c.get("value").setValue(options);
        break;
      }
    }
  }

  picklistValueChanged(event: {
    target: {
      value: any;
      label: any;
      defaultpicklist: any;
    };
  }) {
    if (!event.target.label || event.target.label.trim() === "") {
      console.log("Empty label, skipping processing.");
      return;
    }

    var options = [];
    console.log(event);
    console.log("event", event.target.value);
    console.log("event", event.target.defaultpicklist);

    var txtValue = event.target.value;
    var txtLabel = event.target.label;
    var defPicklist = event.target.defaultpicklist;

    if (txtValue != "") {
      var arr = txtValue.split("\n");
      var arrLbl = txtLabel.split("\n");

      var arrPic = defPicklist.split("\n");

      for (let i = 0; i < arr.length; i++) {
        if (arr[i].trim() != "") {
          options.push({
            value: arr[i],
            label: arrLbl[i],

            defaultpicklist: arrPic[i] === "false" ? false : Boolean(arrPic[i]),
          });
        }
      }
      // console.log(this.valuePicklistForm.controls["sortbyalphabet"].value);
    }

    var optionValue = JSON.stringify(options);
    console.log("value", optionValue);
    this.picklistOptions = options;
    console.log("picklistOptions", this.picklistOptions);

    if (options != null) {
      this.dataSource = options.map((item) => ({
        // id: item.id,
        // label: item.labelname,
        picklistlabel: item.label,
        picklistname: item.value,

        // defaultpicklist: Boolean(item.defaultpicklist),
        defaultpicklist:
          item.defaultpicklist === "false"
            ? false
            : Boolean(item.defaultpicklist),
        sortbyalphabet: this.valuePicklistForm.controls["sortbyalphabet"].value,
      }));
    }

    var arrayControl = this.attributeForm.get("attributeitems") as FormArray;
    for (let c of arrayControl.controls) {
      if (c.get("attr").value == "options") {
        c.get("value").setValue(optionValue);
        // c.get("value").setValue(options);
        break;
      }
    }
  }

  // saveeditPicklist(): void {

  //     if (
  //       this.editPicklistForm.controls["picklistlabel"].value.toString().trim() ==
  //       ""
  //     ) {
  //       this.showWarning("Picklist label is mandatory");
  //       return;
  //     }
  //   if (this.editPicklistForm.valid) {
  //     const formValue = this.editPicklistForm.value;
  //     console.log('Saved picklist:', formValue);
  //     // TODO: call API or push into list here

  //     // / Add some extra fields if needed
  //     const newPicklist = {
  //       ...formValue,
  //       // modifiedby: 'Current User', // or from your logged-in user
  //       // modifieddate: new Date()
  //     };

  //      // ✅ Add to table data
  //     this.dataSource = [...this.dataSource, newPicklist];

  //     // ✅ Close the modal/form
  //     this.showEditPicklistDialog = false;
  //      this.editpicklistdialogRef.close();
  //   } else {
  //     alert('Please fill required fields');
  //   }
  // }

  editPicklistValues(options: any, index: any) {
    console.log(options);
    console.log(index);
    this.selectedIndex = index;

    // this.showEditPicklistDialog = !this.showEditPicklistDialog;
    this.showEditPicklistDialog = true;
    this.oldValues = { options }; // Clone the original options to store as old values

    this.editPicklistForm = this.fb.group({
      picklistlabel: options.picklistlabel,
      picklistname: options.picklistname,
      defaultpicklist: Boolean(options.defaultpicklist) || false,
    });

    this.editpicklistdialogRef = this.dialog.open(this.editPicklistDialog, {
      // data: this.data,
      height: "300px",
      width: "600px",
      // disableClose: true,
      data: { index: index, options: options }, // Pass both index and options
      panelClass: "custom-dialog-class",
    });

    // this.propertiesDialog = dialogRef.componentInstance;
    // this.propertiesDialog.setParent(this);

    this.editpicklistdialogRef.afterClosed().subscribe((result) => {
      console.log("Properties dialog was closed");
      if (result) {
      }
    });
  }

  saveeditPicklist(index: any) {
    if (
      this.editPicklistForm.controls["picklistlabel"].value.toString().trim() ==
      ""
    ) {
      this.showWarning("Picklist label is mandatory");
      return;
    }
    if (
      this.domainForm.get("datatype").value === "lookup" &&
      !this.domainForm.get("relatedto").value
    ) {
      this.showWarning("Related To is mandatory for Lookup datatype");
      return;
    }

    const newValues = this.editPicklistForm.value;

    if (this.selectedIndex == undefined) {
      const valPush = {
        label: newValues.picklistlabel,
        value: newValues.picklistname,
        defaultpicklist: newValues.defaultpicklist,
      };

      this.picklistOptions.push(valPush);

      console.log("Updated options array:", this.picklistOptions);

      var arrayControl = this.attributeForm.get("attributeitems") as FormArray;
      for (let c of arrayControl.controls) {
        if (c.get("attr").value == "options") {
          // c.get("value").setValue(optionValue);
          c.get("value").setValue(this.picklistOptions);
          console.log(c);

          break;
        }
      }

      if (this.picklistOptions != null) {
        this.dataSource = this.picklistOptions.map((item) => ({
          // id: item.id,
          // label: item.labelname,
          picklistlabel: item.label,
          picklistname: item.value,
          defaultpicklist: item.defaultpicklist,
        }));
      }

      console.log(this.picklistOptions);
      var placeholder = "";

      const picklistValuesString = this.picklistOptions
        .map((item) => item.value)
        .join("\n");
      this.valuePicklistForm.controls["placeholder"].setValue(
        picklistValuesString
      );
    }

    // Update the options array with the new values
    if (this.selectedIndex !== undefined && this.selectedIndex >= 0) {
      this.picklistOptions[this.selectedIndex].label = newValues.picklistlabel;
      this.picklistOptions[this.selectedIndex].value = newValues.picklistname;
      this.picklistOptions[this.selectedIndex].defaultpicklist =
        newValues.defaultpicklist;

      console.log("Updated options array:", this.picklistOptions);

      var arrayControl = this.attributeForm.get("attributeitems") as FormArray;
      for (let c of arrayControl.controls) {
        if (c.get("attr").value == "options") {
          // c.get("value").setValue(optionValue);
          c.get("value").setValue(this.picklistOptions);
          console.log(c);

          break;
        }
      }

      if (this.picklistOptions != null) {
        this.dataSource = this.picklistOptions.map((item) => ({
          picklistlabel: item.label,
          picklistname: item.value,
          defaultpicklist: item.defaultpicklist,
        }));
      }

      // // Update the dataSource if necessary
      // this.dataSource[this.selectedIndex] = {
      //   ...this.picklistOptions[this.selectedIndex],
      // };
    }
    const picklistValues = this.picklistOptions
      .map((option) => option.value) // Extract the 'value' from each picklist option
      .join("\n"); // Join them with a new line separator

    const picklistLabels = this.picklistOptions
      .map((option) => option.label) // Extract the 'label' from each picklist option
      .join("\n"); // Join them with a new line separator
    const defaultPicklist = this.picklistOptions
      .map((option) => option.defaultpicklist) // Extract the 'label' from each picklist option
      .join("\n"); // Join them with a new line separator

    const event = {
      target: {
        value: picklistValues,
        label: picklistLabels,
        defaultpicklist: defaultPicklist || false,

        // value: picklistValues, // Use the desired form control value
        // label: picklistLabels,
        // funnelstages : picklistfunnelstages,
        // defaultpicklist: defaultPicklist || false,
        // exclude: exclude || false,
        // addtorecordtype: addtorecordtype || false,
        // converted: converted || false,
        // closed: closed || false,
      },
    };

    this.picklistValueChanged(event);

    this.editpicklistdialogRef.close();
  }

  deletePicklist(label: any, value: any) {
    console.log(label);
    console.log(value);

    this.picklistOptions = this.picklistOptions.filter(
      (option: any) => option.label !== label || option.value !== value
    );
    console.log(this.picklistOptions);
    // this.dataSource = [...this.picklistOptions];
    this.dataSource = this.picklistOptions.map((item) => ({
      // id: item.id,
      // label: item.labelname,
      picklistlabel: item.label,
      picklistname: item.value,
      defaultpicklist: item.defaultpicklist,
      modifiedby: item.modifiedby,
      modifieddate: item.modifieddate,
    }));
  }

  picklistEditValueChanged(event) {
    console.log(event);
  }

  showSuccess(data: any) {
    let options = {
      enableHtml: true,
      positionClass: "md-toast-top-right",
      timeOut: 3000,
    };
    this.toastrService.success(data, "", options);
  }

  showError(data: any) {
    let options = { enableHtml: true, positionClass: "md-toast-bottom-right" };
    this.toastrService.error(data, "Metaobject Error!", options);
  }

  showWarning(data: any) {
    let options = {
      enableHtml: true,
      positionClass: "md-toast-bottom-right",
      messageClass: "orange darken-4",
      toastClass: "warning-color-dark",
    };
    this.toastrService.warning(data, "", options);
  }

  save() {
    if (this.domainForm.controls["name"].value.toString().trim() == "") {
      this.showWarning("name is mandatory");
      return;
    }
    if (this.domainForm.controls["label"].value.toString().trim() == "") {
      this.showWarning("label is mandatory");
      return;
    }
    if (this.domainForm.controls["datatype"].value == "") {
      this.showWarning("datatype is mandatory");
      return;
    }
    if (this.domainForm.controls["sortorder"].value == "") {
      this.showWarning("sortorder is mandatory");
      return;
    }

    if (this.mode.toLowerCase() == "new") {
      this.domainfieldsid = this.guid.getGUID("domainsettingfields");
    }

    let postOption = {
      organizationid: localStorage.getItem("crm_orgid"),
      domain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.domain`
      ),
      subdomain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.subdomain`
      ),
      userid: localStorage.getItem("crm_userid"),
      username: localStorage.getItem("crm_username"),
      useralias: localStorage.getItem("crm_useralias"),

      data: {
        domainsettingfields: {
          id: this.domainfieldsid,
          metaapplicationid: localStorage.getItem("crm_metaapplicationid"),
          mode: this.mode,
          sectionid: this.sectionid,
          name: this.domainForm.controls["name"].value.trim(),
          label: this.domainForm.controls["label"].value.trim(),
          datatype: this.domainForm.controls["datatype"].value.trim(),
          sortorder: this.domainForm.controls["sortorder"].value || 0,
          defaultValue: this.domainForm.controls["defaultvalue"].value.trim(),
          // ✅ don't pass picklistValue directly
          // picklistValue: "",
          minValue: this.domainForm.controls["minvalue"].value || 0,
          maxValue: this.domainForm.controls["maxvalue"].value || 0,
          deprecated: this.domainForm.controls["deprecated"].value,
          active: this.domainForm.controls["active"].value,
          attributes: {}, // will fill below
        },
      },
    };

    // -----------------------------
    // 🟩 Build attributes section
    // -----------------------------
    let attrbs: any = {};

    if (this.domainForm.get("datatype").value === "lookup") {
      attrbs["relatedto"] = this.domainForm.get("relatedto").value;
    }

    postOption.data.domainsettingfields.attributes = JSON.stringify(attrbs);

    let arrayControl = this.attributeForm.get("attributeitems") as FormArray;

    // Normal attributes
    for (let c of arrayControl.controls) {
      let attrKey = c.get("attr").value;
      let attrType = c.get("type").value;
      let attrValue = c.get("value").value;

      attrbs[attrKey] = attrValue;
    }

    // ✅ If datatype is "picklist", store options inside attributes.options
    if (this.domainForm.get("datatype").value === "picklist") {
      let picklistData = this.picklistOptions || [];

      // Optional sorting by alphabet
      if (this.valuePicklistForm.controls["sortbyalphabet"].value === true) {
        picklistData = [...picklistData].sort((a, b) =>
          a.label.localeCompare(b.label)
        );
      }

      attrbs["options"] = picklistData;
    }

    // ✅ Assign stringified attributes to payload
    postOption.data.domainsettingfields.attributes = JSON.stringify(attrbs);

    console.log("Final postOption:", postOption);

    this.isLoading = true;
    this.dataService.upsertDomainSettingFields(postOption).subscribe(
      (res) => {
        if (res.success == 1) {
          this.showSuccess(res.message);
          this.isLoading = false;
          this.router.navigateByUrl(
            `home/domainfieldslist/${this.section}/${this.sectionid}`
          );
        } else {
          this.showError(res.message);
          this.isLoading = false;
        }
      },
      (err) => {
        console.log("Error***:", err);
        this.showError(err.message);
        this.isError = true;
        this.isLoading = false;
      }
    );
  }

  getDomainfieldsedit() {
    return new Promise((resolve, reject) => {
      console.log("getcrudmessages");

      // alert(id)
      const id = this.domainfieldsid;
      const organizationid = localStorage.getItem("crm_orgid");

      // const domain = localStorage.getItem("domain");
      // const subdomain = localStorage.getItem("subdomain");
      const domain = localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.domain`
      );
      const subdomain = localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.subdomain`
      );
      this.isLoading = true;
      this.dataService
        .getDomainFieldsById(domain, subdomain, organizationid, id)
        .subscribe(
          (res) => {
            console.log("res", res);

            // if (res.success == 1) {
            //   this.domainfields = res.data.domainsettingfields[0];
            //   console.log("Doneeee****", this.domainfields);

            //   if (this.domainfields != null) {
            //     this.domainForm.controls["name"].setValue(
            //       this.domainfields.name
            //     );
            //     this.domainForm.controls["label"].setValue(
            //       this.domainfields.label
            //     );
            //     this.domainForm.controls["datatype"].setValue(
            //       this.domainfields.datatype
            //     );
            //     this.domainForm.controls["sortorder"].setValue(
            //       this.domainfields.sortorder
            //     );
            //     this.domainForm.controls["defaultvalue"].setValue(
            //       this.domainfields.defaultvalue
            //     );
            //     // this.domainForm.controls["picklistvalues"].setValue(
            //     //   this.domainfields.picklistValue
            //     // );
            //     this.domainForm.controls["minvalue"].setValue(
            //       this.domainfields.minvalue
            //     );
            //     this.domainForm.controls["maxvalue"].setValue(
            //       this.domainfields.maxvalue
            //     );
            //     this.domainForm.controls["deprecated"].setValue(
            //       this.domainfields.deprecated
            //     );

            //     this.domainForm.controls["active"].setValue(
            //       this.domainfields.active
            //     );
            //     // this.domainForm.controls["attributes"].setValue(
            //     //   this.domainfields.attributes
            //     // );

            //     console.log(this.domainfields.attributes.options);
            //     this.picklistOptions = this.domainfields.attributes.options;
            //     if (this.picklistOptions != null) {
            //       this.dataSource = this.picklistOptions.map((item) => ({
            //         // id: item.id,
            //         // label: item.labelname,
            //         picklistlabel: item.label,
            //         picklistname: item.value,
            //         defaultpicklist: item.defaultpicklist,
            //       }));
            //     }
            //   }

            //   this.isLoading = false;
            // }
            if (res.success == 1) {
              this.domainfields = res.data.domainsettingfields[0];

              let attributes = this.domainfields.attributes || {};

              if (this.domainfields != null) {
                this.domainForm.controls["name"].setValue(
                  this.domainfields.name
                );
                this.domainForm.controls["label"].setValue(
                  this.domainfields.label
                );
                this.domainForm.controls["datatype"].setValue(
                  this.domainfields.datatype
                );
                this.domainForm.controls["sortorder"].setValue(
                  this.domainfields.sortorder
                );
                this.domainForm.controls["defaultvalue"].setValue(
                  this.domainfields.defaultvalue
                );
                this.domainForm.controls["minvalue"].setValue(
                  this.domainfields.minvalue
                );
                this.domainForm.controls["maxvalue"].setValue(
                  this.domainfields.maxvalue
                );
                this.domainForm.controls["deprecated"].setValue(
                  this.domainfields.deprecated
                );
                this.domainForm.controls["active"].setValue(
                  this.domainfields.active
                );

                // ✅ lookup → load relatedto
                if (
                  this.domainfields.datatype === "lookup" &&
                  attributes.relatedto
                ) {
                  this.domainForm.controls["relatedto"].setValue(
                    attributes.relatedto
                  );
                }

                // ✅ picklist → load options
                if (
                  this.domainfields.datatype === "picklist" &&
                  attributes.options
                ) {
                  this.picklistOptions = attributes.options;

                  this.dataSource = this.picklistOptions.map((item) => ({
                    picklistlabel: item.label,
                    picklistname: item.value,
                    defaultpicklist: item.defaultpicklist,
                  }));
                }
              }

              this.isLoading = false;
            } else {
              console.log("Error while saving");
              this.isLoading = false;
            }
          },
          (err) => {
            console.log("Error***:", err);
            this.errorMessage = err.message;
            this.isError = true;
            this.isLoading = false;
            resolve(null);
          }
        );
    });
  }
}
